import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import isBulkActionStale from '../utils/isBulkActionStale';
import Item from 'owa-service/lib/contract/Item';
import setBulkActionInformation from 'owa-bulk-action-store/lib/mutators/setBulkActionInformation';
import { BulkActionStateEnum } from 'owa-bulk-action-store';
import { BulkActionInformation } from 'owa-bulk-action-store/lib/store/schema/BulkActionStateStore';

interface BulkActionProperties {
    BulkActionProcessedCount: number;
    BulkActionStartTime: string;
    BulkActionSendTime: string;
    BulkActionState: number;
    BulkActionTargetFolderId: {
        ChangeKey: string;
        Id: string;
        __type: string;
    };
    ItemId: {
        ChangeKey: string;
        Id: string;
        __type: string;
    };
    BulkActionTotalCount: number;
    BulkActionClass: string;
    BulkActionCustomData: string;
    LastModifiedTime: string;
}

export default function updateBulkActionStore(bulkActionItems: Item[]) {
    for (const bulkActionItem of bulkActionItems) {
        const bulkProps = bulkActionItem as BulkActionProperties;

        // Ensure we only update with running states
        if (bulkProps.BulkActionState != BulkActionStateEnum.Running) {
            continue;
        }

        const folderId = bulkProps.BulkActionTargetFolderId.Id;
        const bulkActionPercentComplete =
            bulkProps.BulkActionProcessedCount / Math.max(1, bulkProps.BulkActionTotalCount);

        const foundBulkActionInformation: BulkActionInformation = {
            id: bulkProps.ItemId.Id,
            targetFolderName: folderIdToName(folderId),
            sendTime: bulkProps.BulkActionSendTime,
            startTime: bulkProps.BulkActionStartTime,
            customData: bulkProps.BulkActionCustomData,
            class: bulkProps.BulkActionClass,
            state: bulkProps.BulkActionState,
            progress: {
                processedCount: bulkProps.BulkActionProcessedCount,
                percentComplete: bulkActionPercentComplete,
                totalCount: bulkProps.BulkActionTotalCount,
            },
        };

        // Update the bulk action find item in the store ONLY if:
        // 1. The bulk action is currently running (above).
        // 2a. The payload does not exists, which can happen if action is running and client freshly booted in OWA.
        // 2b. *OR* The payload is not stale.
        if (!isBulkActionStale(foundBulkActionInformation, folderId)) {
            setBulkActionInformation(folderId, foundBulkActionInformation);
        }
    }
}
